// Nozzle meter vertex schema
// Flow measurement device. Single elevation.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema, MeterMaterialSchema } from '../base/common';

export const NozzleMeterVertexSchema = BaseVertexSchema.extend({
  type: z.literal('nozzle_meter'),
  elevation: ValueWithUnitSchema,
  nozzle_type: z.enum(['long_radius', 'isa1932']),
  meter_diameter: ValueWithUnitSchema,
  device_material: MeterMaterialSchema.optional(),
  pipe_material: MeterMaterialSchema.optional(),
});

export type NozzleMeterVertex = z.infer<typeof NozzleMeterVertexSchema>;
